var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "export_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 97",
    style: {
      enableBackground: "new 0 0 96 97"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.713,26.921l8.332-8.355L89.601,29.89c-0.085,2.138-0.994,4.112-2.567,5.563c-1.569,1.451-3.61,2.199-5.742,2.111 L81.713,26.921z M76.343,13.526L33.395,56.7c-1.557,1.567-1.55,4.098,0.016,5.656c1.566,1.557,4.097,1.551,5.655-0.014 c0.001,0.001,42.95-43.175,42.95-43.175c-0.006-0.006,7.23-7.279,7.23-7.279c1.163-1.169,1.489-2.932,0.823-4.438 c-0.667-1.506-2.189-2.453-3.837-2.379L65.582,6.03c-2.137,0.055-4.11,0.974-5.552,2.554c-1.444,1.576-2.182,3.62-2.083,5.752 C57.947,14.336,76.339,13.517,76.343,13.526z M65.578,44.473H65.5v0.078c0,0.004,0,37.387,0,37.387h-52V29.981h38.418 c0.004,0,0.082,0,0.082,0v-0.078l7.914-7.926L52,21.989c0-0.008-39.4-0.008-39.4-0.008c-3.915,0-7.1,3.184-7.1,7.098v53.762 c0,3.914,3.185,7.098,7.1,7.098h53.8c3.915,0,7.1-3.184,7.1-7.098V44.473c-0.008,0,0.004-7.914,0.004-7.914L65.578,44.473z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.cb4281e83a3bfc638001b1dfbf1a30f2.svg";
export { ForwardRef as ReactComponent };